import { white } from '@/theme/colors'
import styled from 'styled-components'

export const FilterBar = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	color: ${white};
	/* Push the date controls (and the Back link after them) to the right of the nav. */
	margin-left: auto;

	@media (max-width: 600px) {
		gap: 0.5rem;
		flex-wrap: wrap;
	}
`

export const Presets = styled.div`
	display: flex;
	align-items: center;
	gap: 0.35rem;
`

export const PresetButton = styled.button<{ $active?: boolean }>`
	font: inherit;
	font-size: 0.8rem;
	font-weight: ${({ $active }) => ($active ? 700 : 500)};
	padding: 0.3rem 0.6rem;
	border-radius: 6px;
	cursor: pointer;
	color: ${white};
	border: 1px solid ${({ $active }) => ($active ? white : 'rgba(255, 255, 255, 0.4)')};
	background-color: ${({ $active }) =>
		$active ? 'rgba(255, 255, 255, 0.22)' : 'rgba(255, 255, 255, 0.08)'};

	&:hover {
		border-color: ${white};
	}
`

export const FilterLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: 0.85rem;
	font-weight: 500;
	opacity: 0.9;
`

export const DateInput = styled.input`
	font: inherit;
	font-size: 0.85rem;
	padding: 0.3rem 0.5rem;
	border: 1px solid rgba(255, 255, 255, 0.4);
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.12);
	color: ${white};
	color-scheme: dark;

	&:focus {
		outline: none;
		border-color: ${white};
	}
`
